export default {
    GET_MASTER_BUDGET: "[zina_flow][master_budget] get all master_budget",
    GET_MASTER_BUDGET_SUCCESS: "[zina_flow][master_budget] get all master_budget SUCCESS",
    GET_MASTER_BUDGET_FAIL: "[zina_flow][master_budget] get all master_budget FAIL",
    UPDATE_PAGINATION: "[zina_flow][master_budget] update master_budget pagination",
    CHANGE_PAGE: "[zina_flow][master_budget] change master_budget page",
    FILTER_LIST: "[zina_flow][master_budget] change master_budget filters",
    
    GET_CHOICES: "[zina_flow][master_budget] get choices",
    GET_CHOICES_SUCCESS: "[zina_flow][master_budget] get choices success",
    GET_CHOICES_FAIL: "[zina_flow][master_budget] get choices fail",
    
};
